import { apiService } from 'core/services';
import type { IPostHierarchyTreeSubitemsOrder } from 'core/services/navigation/hierarchy.dto';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { getErrorFromService } from 'shared/utils/https';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import { getUnexpectedErrorMessages } from '../../navigation.utils';
import type { INavigationState } from '../../types';

export const arrangeNavigationSubitem = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/arrangeNavigationSubitem`,
  async (data: IPostHierarchyTreeSubitemsOrder) => {
    try {
      await apiService.hierarchy.updateHierarchySubitemsOrder(data);
      notificationService.global.success('Submundo ordenado correctamente.');
    } catch (error) {
      notificationService.global.error(getErrorFromService(error, getUnexpectedErrorMessages('subitems', 'arrange')));
      throw error;
    }
  },
);

export const arrangeNavigationSubitemReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(arrangeNavigationSubitem.pending, state => {
      state.navigationList.loading.status = true;
    })
    .addCase(arrangeNavigationSubitem.rejected, state => {
      state.navigationList.loading.status = false;
    })
    .addCase(arrangeNavigationSubitem.fulfilled, state => {
      state.navigationList.loading.status = false;
    });
